import { parseRef, toDisplay } from "./refs.js";
/** "Nehemiah 1" for a chapter, "Home" for the front page; any other path as it is. */
export function statsPageLabel(path) {
    if (path === "/")
        return "Home";
    const m = /^\/commentary\/([^/]+)\/(\d+)$/.exec(path);
    if (!m)
        return path;
    try {
        return toDisplay(parseRef(`${m[1].replace(/-/g, " ")} ${m[2]}`));
    }
    catch {
        return path;
    }
}
/**
 * Hosts, as the stats keep them (lowercase, without "www."), that mean a
 * Facebook reader — its apps and sites, not Instagram. Written to be read by
 * JavaScript and by Postgres both (`~`), so the tables and the tests agree.
 */
export const FACEBOOK_HOSTS = String.raw `(^|\.)(facebook\.com|fb\.com|fb\.me|messenger\.com)$`;
export const SEARCH_HOSTS = String.raw `(^|\.)(google\.[a-z.]+|bing\.com|duckduckgo\.com|yahoo\.com|ecosia\.org|search\.brave\.com|baidu\.com|yandex\.[a-z.]+|startpage\.com|kagi\.com|qwant\.com)$`;
/** The bucket a referring host belongs to; null is a direct visit. */
export function statsSourceOf(host) {
    if (!host)
        return "direct";
    if (new RegExp(FACEBOOK_HOSTS).test(host))
        return "facebook";
    if (new RegExp(SEARCH_HOSTS).test(host))
        return "search";
    return "other";
}
//# sourceMappingURL=stats.js.map